import { CircularProgress } from '@mui/material';
import { Onboarding } from './components/Onboarding';
import { useHomeViewModel } from './home.viewModel';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { CreatorLinks } from './components/CreatorLinks';
import { CreatorInformationSections } from './staticContent/CreatorInformationSections';
import { Header } from './components/Header';
import { CaseStudies } from './components/CaseStudies';
import { IOSAppQrCodeModal } from './components/IosAppQrCodeModal';
import { Feedback } from './components/Feedback';
import { OfferModal } from './components/OfferModal';
import { GoLiveModal } from './components/GoLiveModal';
import { LiveSuccessModal } from './components/LiveSuccessModal';
import { EducationCloseConfirmationModal } from './components/EducationCloseConfirmationModal';

export const HomePage = (p: { params: { influencerId?: string } }) => {
  const vm = useHomeViewModel({ influencerId: p.params.influencerId });

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<CircularProgress />}
      renderer={(data) => (
        <div className="w-full flex flex-col gap-8 lg:gap-10 max-w-[1200px] mx-auto">
          <Header {...data.headline} />
          <Onboarding {...data.onboarding} />
          <CreatorLinks {...data.links} dispatch={data.dispatch} />
          <CreatorInformationSections isLive={data.isLive} />
          <IOSAppQrCodeModal
            isOpen={data.qrCodeModal.open}
            onClose={data.qrCodeModal.onClose}
          />
          <OfferModal {...data.offerModal} />
          <EducationCloseConfirmationModal
            {...data.educationCloseConfirmation}
          />
          <GoLiveModal {...data.goLiveModal} />
          <LiveSuccessModal {...data.liveSuccessModal} />
          <Feedback {...data.feedback} />
          <CaseStudies />
        </div>
      )}
    />
  );
};
